import { get } from "@/lib/api";

export async function getOrderConfig() {
  return get("/order/config", { useApiKey: true });
}